import axios from 'axios';
import { baseurl } from '../constants/constants';

export const baseApi = axios.create({
	baseURL: baseurl
})